// NPOLAR GT LAB PAGE - JS
document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.npolar-before-after');

  wrappers.forEach(function (wrapper) {
    const after = wrapper.querySelector('.npolar-after-wrap');
    const line = wrapper.querySelector('.npolar-slider-line');
    const handle = wrapper.querySelector('.npolar-slider-handle');

    if (!after || !line || !handle) return;

    let isDragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));

      after.style.width = percent + '%';
      line.style.left = percent + '%';
      handle.style.left = percent + '%';
    }

    function move(clientX) {
      const rect = wrapper.getBoundingClientRect();
      const percent = ((clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    wrapper.addEventListener('mousedown', function (event) {
      isDragging = true;
      move(event.clientX);
      event.preventDefault();
    });

    window.addEventListener('mousemove', function (event) {
      if (!isDragging) return;
      move(event.clientX);
    });

    window.addEventListener('mouseup', function () {
      isDragging = false;
    });

    wrapper.addEventListener('touchstart', function (event) {
      isDragging = true;
      move(event.touches[0].clientX);
    }, { passive: true });

    window.addEventListener('touchmove', function (event) {
      if (!isDragging) return;
      move(event.touches[0].clientX);
    }, { passive: true });

    window.addEventListener('touchend', function () {
      isDragging = false;
    });

    setPosition(50);
  });
});